import { NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import { CutoutTypeEnum } from '../../models/cutting/cutting-panel-outline.model';
import { CuttingStandardCutout } from '../../models/cutting/cutting-standard-cutout.model';

@Component({
  selector: 'csl-standard-cutout-select',
  templateUrl: 'standard-cutout-select.component.html',
  standalone: true,
  imports: [MatLegacyTableModule, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet],
})
export class StandardCutoutSelectComponent implements OnInit {
  cutoutTypeEnum = CutoutTypeEnum;
  displayedColumns = ['image', 'name', 'height', 'width', 'radius', 'type'];

  anyCutoutName = $localize`Параметрический вырез`;

  @Input() cutouts: CuttingStandardCutout[] = [];
  @Input() panelHeight = 0;
  @Input() panelWidth = 0;

  @Output() selectChanged: EventEmitter<CuttingStandardCutout | undefined> = new EventEmitter();

  ngOnInit(): void {
    if (this.panelHeight <= 0 || this.panelWidth <= 0) return;

    this.cutouts = this.cutouts.filter(c => c.height <= this.panelHeight && c.width <= this.panelWidth);
  }

  getCutoutTypeName(type: CutoutTypeEnum): string {
    const names = {
      [CutoutTypeEnum.Any]: $localize`Любой`,
      [CutoutTypeEnum.Rectangle]: $localize`Прямоугольник`,
      [CutoutTypeEnum.RoundedRectangle]: $localize`Прямоугольник со скруглёнными углами`,
      [CutoutTypeEnum.Ellipse]: $localize`Окружность`,
      [CutoutTypeEnum.Fragment]: $localize`Фрагмент`,
    };

    return names[type];
  }
}
